const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const {CircleCheck} = require("lucide-react");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const OpsUser = require("../../core/vault/OpsUser");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/PageRedeemSubscription.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	Component = withAnimateScroll(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CreateAccountForm",

		propTypes: {
			cart: PT.object.isRequired,
			user: PT.object.isRequired,
			onContinue: PT.func,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateScroll: PT.func.isRequired,
		},

		vaultEvents: {
			userExistsWithEmail: function() {
				this.setState({
					accountExists: true,
					showEmailError: true,
				});
			},
			userDoesNotExistWithEmail: function() {
				this.setState({accountExists: false});
			},
		},

		getInitialState: function() {
			this.alreadyScrolledToError = true;
			const firstName = this.props.cart.form.data.account.firstName;
			const lastName = this.props.cart.form.data.account.lastName;
			const isNewAccount = !OpsUser.isLoggedIn(this.props.user);
			return {
				isNewAccount: isNewAccount,
				hasSubmitted: false,
				accountExists: false,
				emailValid: false,
				passwordValid: false,
				passwordRepeatValid: false,
				showPasswordError: false,
				showEmailError: false,
				showPasswordRepeatError: false,
				email: this.props.cart.form.data.account.email || "",
				password: this.props.cart.form.data.account.password || "",
				passwordRepeat: this.props.cart.form.data.account.passwordRepeat || "",
				firstName,
				lastName,
				showFirstNameError: false,
				showLastNameError: false,
			};
		},

		statics: {
			getDerivedStateFromProps: function(props, state) {
				const existingValidation = props.cart.form.validation;
				if (existingValidation.account.isComplete) {
					return {
						emailValid: true,
						passwordValid: true,
						passwordRepeatValid: true,
					};
				}
				return {};
			},
		},

		componentDidUpdate: function(prevProps) {
			if (
				!OpsUser.isLoggedIn(prevProps.user) &&
				OpsUser.isLoggedIn(this.props.user)
			) {
				this.setState({isNewAccount: false});
			}
		},

		augmentValidation: function(validation, key) {
			if (!this.state[key]) {
				validation.isComplete = false;
				validation.missing.push(key);
				validation.errorTypes[key] = {type: "E_MISSING"};
			} else {
				_.pull(validation.missing, key);
				delete validation.errorTypes[key];
			}
			return validation;
		},

		getValidation: function() {
			const {cart, user} = this.props;
			let validation = OpsCart.checkFormSection(cart, "account");
			validation = _.cloneDeep(validation);
			if (OpsUser.isLoggedIn(user)) {
				// We should never get this case anyway, but fake the validation.
				validation = {
					missing: [],
					invalid: [],
					errorTypes: {},
					isComplete: true,
				};
			} else {
				validation = this.augmentValidation(validation, "firstName");
				validation = this.augmentValidation(validation, "lastName");
			}
			if (!this.state.hasSubmitted) {
				validation.missing = [];
			}
			_.each(validation.errorTypes, (f, key) => {
				// Unset missing in errorTypes if not in missing fields
				if (f.type === "E_MISSING" && !_.includes(validation.missing, key)) {
					f.type = "";
				} else if (!f.type && _.includes(validation.missing, key)) {
					f.type = "E_MISSING";
				}
			});
			return validation;
		},

		updateField: function(field, val) {
			this.setState({[field]: val});
			if (field === "email") {
				this.setState({accountExists: false});
				this.props.dispatch({
					type: AT.UPDATE_CART_FORMDATA,
					section: "account",
					vals: {email: val},
				});
			} else {
				this.props.dispatch({
					type: AT.UPDATE_CART_FORMDATA,
					section: "account",
					vals: {[field]: val},
				});
			}
		},

		validateField: function(field, value, checkAccountExists = false) {
			this.updateField(field, value);

			// This ensures the field actually gets updated before validation
			setTimeout(() => {
				const validation = this.getValidation();
				const errorType = _.get(validation.errorTypes, `${field}.type`);
				const isValid = value && !errorType;
				this.setState({[`${field}Valid`]: isValid});
				if (field === "email" && isValid && checkAccountExists) {
					const reqData = {
						type: AT.CHECK_USER_EXISTS_REQUEST,
						email: this.props.cart.form.data.account.email,
					};
					this.props.dispatch(reqData);
				}
			}, 0);
		},

		validateAndSubmit: function() {
			// validate email field (check account exists) if it's still focused
			if (document.activeElement === document.getElementById("email")) {
				this.validateField("email", this.state.email, true);
			}
			this.setState({
				hasSubmitted: true,
				accountExists: false,
				showEmailError: true,
				showPasswordError: true,
				showPasswordRepeatError: true,
			});
			setTimeout(() => {
				const validation = this.getValidation();
				if (validation.isComplete) {
					this.props.onContinue();
				} else {
					this.alreadyScrolledToError = false;
					this.props.dispatch({
						type: AT.SHOW_ALL_CHECKOUT_VALIDATION,
						step: "account",
					});
				}
			}, 0);
		},

		handleKeyDown: function(e) {
			if (e.key === "Enter") {
				e.preventDefault();
				if (
					this.state.emailValid &&
					this.state.passwordValid &&
					this.state.passwordRepeatValid &&
					!this.state.accountExists
				) {
					this.validateAndSubmit();
				}
			}
		},

		startLogin: function() {
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		startLogout: function() {
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				forSwitch: true,
			});
		},

		render: function() {
			const validation = this.getValidation();
			const errorFields = _.pick(validation, [
				"missing",
				"invalid",
				"errorTypes",
			]);

			const emailError = _.get(errorFields.errorTypes, "email.type");
			const firstNameError = _.get(errorFields.errorTypes, "firstName.type");
			const lastNameError = _.get(errorFields.errorTypes, "lastName.type");
			const passwordError = _.get(errorFields.errorTypes, "password.type");
			const passwordRepeatError = _.get(
				errorFields.errorTypes,
				"passwordRepeat.type"
			);

			const emailErrorMessages = CopyTable.getFormInvalidCopy("email");
			const firstNameErrorMessages = CopyTable.getFormInvalidCopy("firstName");
			const lastNameErrorMessages = CopyTable.getFormInvalidCopy("lastName");
			const passwordErrorMessages = CopyTable.getFormInvalidCopy("password");
			let passwordRepeatErrorMessages = CopyTable.getFormInvalidCopy(
				"passwordRepeat"
			);
			passwordRepeatErrorMessages = _.extend(
				passwordRepeatErrorMessages,
				CopyTable.getFormErrorCopy("E_MISSING")
			);

			const firstNameEl = (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="firstName">
						First Name
					</label>
					<div className={styles.inputWrapper}>
						<input
							id="firstName"
							type="text"
							placeholder="First Name"
							value={this.state.firstName}
							onChange={e => {
								this.validateField("firstName", e.target.value);
								this.setState({firstNameError: false});
							}}
							autoFocus
						/>
					</div>
					{firstNameError && (
						<div className={styles.errorMessage}>
							{"* " + firstNameErrorMessages[firstNameError || "E_MISSING"]}
						</div>
					)}
				</div>
			);

			const lastNameEl = (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="lastName">
						Last Name
					</label>
					<div className={styles.inputWrapper}>
						<input
							id="lastName"
							type="text"
							placeholder="Last Name"
							value={this.state.lastName}
							onChange={e => {
								this.validateField("lastName", e.target.value);
								this.setState({lastNameError: false});
							}}
						/>
					</div>
					{lastNameError && (
						<div className={styles.errorMessage}>
							{"* " + lastNameErrorMessages[lastNameError || "E_MISSING"]}
						</div>
					)}
				</div>
			);

			const emailEl = (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="email">
						Email
					</label>
					<div
						className={
							(emailError && this.state.showEmailError) ||
							this.state.accountExists
								? styles.inputWrapperError
								: styles.inputWrapper
						}
					>
						<input
							id="email"
							type="email"
							placeholder="yourname@mail.com"
							value={this.state.email}
							onChange={e => {
								this.validateField("email", e.target.value, false);
								this.setState({showEmailError: false});
							}}
							onBlur={e => {
								if (!this.state.accountExists) {
									this.validateField("email", e.target.value, true);
								}
								this.setState({showEmailError: true});
							}}
							autoComplete="email"
						/>
					</div>
					{this.state.accountExists ? (
						<div className={styles.errorMessage}>
							{"* This account already exists. "}
							<a href="#" onClick={this.startLogin}>
								{"Sign in"}
							</a>
							{"."}
						</div>
					) : (
						this.state.showEmailError &&
						emailError && (
							<div className={styles.errorMessage}>
								{"* " + emailErrorMessages[emailError || "E_MISSING"]}
							</div>
						)
					)}
				</div>
			);

			const passwordEl = (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="password">
						Create a Password
					</label>
					<div
						className={
							passwordError && this.state.showPasswordError
								? styles.inputWrapperError
								: styles.inputWrapper
						}
					>
						<input
							id="password"
							type="password"
							placeholder="**********"
							value={this.state.password}
							onChange={e => {
								this.validateField("password", e.target.value);
								this.validateField("passwordRepeat", this.state.passwordRepeat);
								this.setState({
									showPasswordError: false,
									showPasswordRepeatError: false,
								});
							}}
							onBlur={e => {
								this.setState({
									showPasswordError: true,
									showPasswordRepeatError: true,
								});
							}}
							autoComplete="new-password"
						/>
					</div>
					{this.state.showPasswordError && passwordError && (
						<div className={styles.errorMessage}>
							{"* " + passwordErrorMessages[passwordError || "E_MISSING"]}
						</div>
					)}
				</div>
			);

			const passwordRepeatEl = (
				<div className={styles.inputContainer}>
					<label className={styles.inputLabel} htmlFor="passwordRepeat">
						Confirm Password
					</label>
					<div
						className={
							passwordRepeatError && this.state.showPasswordRepeatError
								? styles.inputWrapperError
								: styles.inputWrapper
						}
					>
						<input
							id="passwordRepeat"
							type="password"
							placeholder="**********"
							value={this.state.passwordRepeat}
							onChange={e => {
								this.validateField("passwordRepeat", e.target.value);
								this.setState({showPasswordRepeatError: false});
							}}
							onBlur={e => {
								this.setState({showPasswordRepeatError: true});
							}}
							autoComplete="new-password"
						/>
					</div>
					{this.state.showPasswordRepeatError && passwordRepeatError && (
						<div className={styles.errorMessage}>
							{"* " +
								passwordRepeatErrorMessages[passwordRepeatError || "E_MISSING"]}
						</div>
					)}
					{!passwordError &&
						!passwordRepeatError &&
						this.state.passwordRepeatValid &&
						this.state.passwordValid && (
							<div className={styles.successMessage}>
								<span className={styles.checkmark}>
									<CircleCheck />
								</span>
								Passwords match
							</div>
						)}
				</div>
			);

			const continueEl = (
				<button
					className={styles.primaryButtonAccountForm}
					type="submit"
					onClick={this.validateAndSubmit}
					disabled={
						!(
							this.state.emailValid &&
							this.state.passwordValid &&
							this.state.passwordRepeatValid &&
							!this.state.accountExists
						)
					}
				>
					Continue
				</button>
			);

			return (
				<div className={styles.form} onKeyDown={this.handleKeyDown}>
					{firstNameEl}
					{lastNameEl}
					{emailEl}
					{passwordEl}
					{passwordRepeatEl}
					{continueEl}
				</div>
			);
		},
	})
);
